export const getApplicationLocale = state => state.application.language.locale;

export const getApplicationLanguageId = state => state.application.language.id;

export const getApplicationLanguageCode = state =>
  state.application.language.cultureCode || 'fi-FI';
